/**
 * Maximum number of entities to display in bar chart
 */ export const MaxDisplayableEntitiesOnBarChart = 25;
/**
 * Minimum number of characters a user needs to type before a search executes
 */ export const MinCharsNeededToSearch = 2;
/**
 * Time interval in milliseconds between user activity sampling
 */ export const UserActivitySamplingResolutionMs = 60000;
